import React from 'react';

import useLediumPage from '@client/hooks/useLediumPage';
import { usePageStore } from '@client/store/pageStore/context/pageContext';
import aggregateSpectrograms from '@client/utils/aggregateSpectrograms';
import { SpectrogramPoint } from '@ledium/types';

import { MixerChannel } from './Components/SpectrumMixerChannelSettingsItem';
import SpectrumMixerView from './SpectrumMixerView';

const SpectrumMixer = () => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();
    const lightChannels = formData.lightChannels as MixerChannel[];
    const lightRecipe = formData.lightRecipe as { id?: string; spectrogram?: SpectrogramPoint[] } | null;

    const { mainMenu, onSave } = useLediumPage({
        saveDataMap: () => ({
            name: formData.name,
            description: formData.description,
            groupId: formData.groupId,
            lightChannels: lightChannels.map((lightChannel) => ({
                id: lightChannel.id,
                intensity: lightChannel.intensity,
                intensityPercent: lightChannel.intensityPercent,
                intensityRanges: lightChannel.intensityRanges
            })),
            lightRecipeId: lightRecipe?.id
        })
    });

    React.useEffect(() => {
        const intensityRanges: Record<string, Record<string, number>> = {};
        for (const unit of ['pfd', 'irradiance'] as const) {
            intensityRanges[unit] = {};
            if (lightChannels) {
                lightChannels.forEach((channel) => {
                    const rangeUnit = channel.intensityRanges[unit] as unknown as Record<string, number>;
                    for (const category in rangeUnit) {
                        if (intensityRanges[unit][category] === undefined) {
                            intensityRanges[unit][category] = 0;
                        }
                        intensityRanges[unit][category] += rangeUnit[category];
                    }
                });
            }
        }
        pageActions.formData.updateFormItem({ intensityRanges });
    }, [formData.lightChannels]);

    React.useEffect(() => {
        if (lightChannels) {
            const aggregatedSpectrogram = aggregateSpectrograms(lightChannels, lightRecipe);
            pageActions.formData.updateFormItem({ aggregatedSpectrogram });
        }
    }, [formData.lightChannels, formData.lightRecipe]);

    if (!formData.loaded) {
        return null;
    }

    return <SpectrumMixerView onSave={onSave} onClose={mainMenu} />;
};

export default SpectrumMixer;
